import { render, staticRenderFns } from "./BaseNavigationTabs.vue?vue&type=template&id=6e768b8f&lang=pug"
import script from "./BaseNavigationTabs.vue?vue&type=script&lang=js"
export * from "./BaseNavigationTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e768b8f')) {
      api.createRecord('6e768b8f', component.options)
    } else {
      api.reload('6e768b8f', component.options)
    }
    module.hot.accept("./BaseNavigationTabs.vue?vue&type=template&id=6e768b8f&lang=pug", function () {
      api.rerender('6e768b8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/BaseNavigationTabs.vue"
export default component.exports